<button (click)="openChat()" data-testid="openConversationalDialog">Open Chat</button>

<div>
    <h2>Stuur een berichtje:</h2>
    <button (click)="sendTestMessage('Test')" data-testid="faq-question-01">Test</button>
    <button (click)="sendTestMessage('Mooi')" data-testid="faq-question-02">Mooi</button>
</div>

<mijn-klant-conversational></mijn-klant-conversational>
